//let dns = 'http://backend.residenceit.com';
//"username": "residenceit",
//"password": "residence@it
    
let dns = 'https://backend.residenceit.com';

export default dns;
